<template>
	<div>
		<div
			v-if="loading"
			class="loader">
			<img
				:src="require('@/assets/images/presale_open_bulldroids.gif')"
				class="no_lazy"
				alt="">
		</div>
		<div
			v-else-if="error"
			class="message">
			<p
				v-if="error"
				class="error">
				Error: {{ error }}
			</p>
		</div>
		<div
			v-else-if="bulldroids.length === 0"
			class="wrapper">
			<div class="message">
				<p>
					You currently have no Bulldroids.
					You can buy it directly on Opensea.
				</p>
				<a
					href="https://opensea.io/collection/bulldroids-nft"
					class="button_big"
					target="_blank"><img
						:src="require('@/assets/images/opensea_button.png')"
						alt=""></a>
			</div>
		</div>
		<div
			v-else
			class="wrapper">
			<BulldroidCard
				v-for="bulldroid in bulldroids"
				:key="bulldroid.name"
				:bulldroid="bulldroid" />
		</div>
	</div>
</template>

<script setup>
import { useBulldroid } from '@/composables/bulldroid';

import BulldroidCard from '@/components/BulldroidCard.vue';

const props = defineProps({
	account: {
		type: String,
		required: true,
	},
});

const {
	loading,
	error,
	bulldroids,
} = useBulldroid(props.account);
</script>
